import { Component, ViewChild, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LocalStorageService } from './utility/localStorageService';
import moment from 'moment';
import { NotesService } from './shared/services/calls.services';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent } from './shared/dialogs/confirm-dialog/confirm-dialog.component';
import { ProfileDialogComponent } from './shared/dialogs/profile-dialog/profile-dialog.component';
import { SettingsDialogComponent } from './shared/dialogs/settings-dialog/settings-dialog.component';
import { ActivityLogDialogComponent } from './shared/dialogs/activity-log-dialog/activity-log-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { IdleService } from './idle-dialog/Idle-Service';
import { environment } from 'src/environments/environment';
import { IdleWarningModalComponent } from './idle-dialog/idle-dialog.component';
import { PermissionService } from './utility/PermissionService';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  @ViewChild('sidenav') sidenav!: MatSidenav;
  isDarkTheme = false;
  // --- your variables unchanged ---
  userType: string;
  showLayout = true;
  expanded: { [key: string]: boolean } = {};
  menuItems: any[] = [];
  spinner: boolean = false;
  modalRef: BsModalRef;
  activeCount = 3;
  inactiveCount = 1;
  mobileMenuOpen = false;
  currentYear: any;
  userName: string;
  androidOS: boolean = false;
  onDate: string;
  cntNewLeads: number = 0;
  cntFolloUps: number = 0;
  followUpList = [];
  newLeadsTillToday = [];

  countdown = 0;
  userContinued: boolean = true
  warningSub: Subscription;
  timeoutSub: Subscription;

  constructor(
    private router: Router,
    private localStorage: LocalStorageService,
    private notesService: NotesService,
    private modalService: BsModalService,
    private idleService: IdleService,
    private dialog: MatDialog,
    private permissionService: PermissionService,
    private renderer: Renderer2
  ) {




    const savedTheme = this.localStorage.get('theme');
    if (savedTheme === 'dark') {
      document.body.classList.add('dark-theme');
    }

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        const currentUrl = event.urlAfterRedirects || event.url;
        this.showLayout = !currentUrl.includes('/login');
      });
  }
  
  // -------------------- IDLE WATCHER --------------------

  // -------------------- CLEANUP --------------------
  ngOnDestroy() {
    this.warningSub?.unsubscribe();
    this.timeoutSub?.unsubscribe();
  }

  // -------------------- ONINIT --------------------
  ngOnInit(): void {

    //this.startIdleWatch();

    const savedTheme = this.localStorage.get('theme');
    if (savedTheme === 'dark') {
      this.isDarkTheme = true;
      this.renderer.addClass(document.body, 'dark-theme');
    }


    this.notesService.getMenus().subscribe({
      next: (data) => {
        if (data) {
          this.menuItems = data;
          this.permissionService.setPermissions(this.menuItems);
          this.localStorage.set('menus', JSON.stringify(this.menuItems));
        }
      },
      error: (err) => console.error('Error fetching menu:', err)
    });

    this.currentYear = new Date().getFullYear();

    this.userType = this.localStorage.get("userType");
    let refNo = this.userType !== "Admin" ? Number(this.localStorage.get("refNo")) : 0;

    this.onDate = moment(new Date()).format('YYYY-MM-DD').toString();
    this.userName = this.localStorage.get("userName");

    this.notesService.getNewLeadsTillTodate(refNo, this.onDate).subscribe(resp => {
      resp.forEach(e => {
        if (!e.viewedBy || !e.viewedBy.includes(this.userName)) {
          e.display = true;
          this.newLeadsTillToday.push(e);
        }
      });
      this.cntNewLeads = this.newLeadsTillToday.length;
    });

    this.notesService.getLeadANotesByIdAndDate(refNo, this.onDate).subscribe(resp => {
      resp.forEach(e => {
        if (!e.viewedBy || !e.viewedBy.includes(this.userName)) {
          e.display = true;
          this.followUpList.push(e);
        }
      });
      this.cntFolloUps = this.followUpList.length;
    });

    setTimeout(() => {
      this.androidOS = this.getOS() === "Android";
    }, 100);
  }

  // -------------------- UI Helpers --------------------
  toggleSubMenu(title: string): void {
    this.expanded[title] = !this.expanded[title];
  }

  toggleSidenav(): void {
    this.sidenav.toggle();
  }

  closeOnMobile(): void {
    this.sidenav.close();
  }

  closeSidenav(): void {
    this.sidenav.close();
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  spinnerStatus(status: boolean) {
    this.spinner = status;
  }

  Profile() {
    this.modalRef = this.modalService.show(ProfileDialogComponent, { class: 'modal-dialog modal-dialog-centered modal-sm' });
  }

  logOutClick() {
    const modalConfig = { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false };
    const initialState = { mode: 'Logout', module: 'Logout', refNo: '0' };
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, modalConfig, { class: 'modal-sm', initialState }));
  }

  settingsClick() {
    this.modalRef = this.modalService.show(SettingsDialogComponent, { class: 'modal-dialog modal-dialog-centered modal-sm' });
  }

  activityLog() {
    this.modalRef = this.modalService.show(ActivityLogDialogComponent, { class: 'modal-dialog modal-dialog-centered modal-lg' });
  }

  getOS() {
    var uA = navigator.userAgent || navigator.vendor;
    if ((/iPad|iPhone|iPod/.test(uA)) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';

    var i, os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], 'i').test(uA)) return os[i];
  }






  startIdleWatch() {
    if (window.location.href.includes("login")) return;

    this.idleService.startWatching();

    this.warningSub = this.idleService.warning$.subscribe(seconds => {
      this.userContinued = false;
      if (!this.modalRef) {
        this.openIdleModal(seconds);
      } else {
        (this.modalRef.content as any).seconds = seconds;
      }
    });

    this.timeoutSub = this.idleService.timeout$.subscribe(() => {
      // If user already continued, ignore timeout event
      if (this.userContinued) return;

      this.modalRef?.hide();
      this.logoutUser();
    });
  }

  openIdleModal(seconds: number) {

    this.userContinued = false; // reset flag when modal opens

    this.modalRef = this.modalService.show(IdleWarningModalComponent, {
      backdrop: 'static',
      keyboard: false,
      class: 'modal-sm'
    });

    const content = this.modalRef.content as IdleWarningModalComponent;
    content.seconds = seconds;

    // Continue
    content.onContinue = () => {
      console.log('Continue clicked');
      this.idleService.extendSession();
      this.userContinued = true; // prevent immediate timeout
      this.modalRef.hide();
    };

    // Logout
    content.onLogout = () => {
      console.log('Logout clicked');
      this.userContinued = false;
      this.logoutUser();
      this.modalRef.hide();
    };
  }


  logoutUser() {
    this.localStorage.set("token", null)
    window.location.href = environment.baseUrl
    console.log("User logged out");
    // your logout logic
  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;

    if (this.isDarkTheme) {
      this.renderer.addClass(document.body, 'dark-theme');
      this.localStorage.set('theme', 'dark');
    } else {
      this.renderer.removeClass(document.body, 'dark-theme');
      this.localStorage.set('theme', 'light');
    }
  }
}
